import { CSpinner } from '@coreui/react-pro';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import { PRODUCT_TYPES_REQUIRE_EVENT, SUBSCRIBER_PATH } from '../../../../constants';
import { useActiveProduct } from '../../../../helpers/customHook';
import { toastError } from '../../../../utils';
import { API_GUEST_SUBSCRIBER_PRODUCT_DETAIL_BY_ID, fetchSubscriberProductDetailRequest } from '../../Subscriber/Products/actions';
import TrainingEventDetails from './CourseTypes/OnlineLiveTraining/TrainingEventDetails';
import TrainingSeatDetails from './TrainingSeatDetails';
import EventCredits from './EventCredits';
import BundleSeats from './BundleSeats';

const TrainingSeats = React.lazy(() => import('./index'));
const Seats = React.lazy(() => import('./Seats'));

const GetCourseProductName = () => {
     const dispatch = useDispatch();
     const location = useLocation();
     const product = useActiveProduct();
     const organizationCourses = useSelector((state) => state.subscriber.organizationCourses);
     const pathNameArr = location.pathname.split('/').filter((path) => path);
     const courseId = pathNameArr[pathNameArr.length - 2];
     const organizationCourseRelated = organizationCourses.find((orgCourse) => orgCourse.id === courseId && !orgCourse.isCredit);
     const [productRelated, setProductRelated] = useState();

     useEffect(() => {
          if (organizationCourseRelated) {
               dispatch(setIsLoading(true));
               callApi(API_GUEST_SUBSCRIBER_PRODUCT_DETAIL_BY_ID.replace(':id', organizationCourseRelated.productId), 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              setProductRelated(response.data);
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => dispatch(setIsLoading(false)));
          }
     }, [organizationCourseRelated]); // eslint-disable-line react-hooks/exhaustive-deps

     if (!product) {
          return <CSpinner width={15} height={15} />;
     }

     let nameBreadcrumb = productRelated?.publishName || product?.publishName;

     if (
          (!location.pathname.includes('seats') || location.pathname.includes('event')) &&
          product?.relatedProductProductId &&
          product.relatedProductSubject
     ) {
          nameBreadcrumb = product?.relatedProductSubject;
     }

     return nameBreadcrumb || '';
};

const GetCourseProductNameEvent = ({ match }) => {
     const dispatch = useDispatch();
     const slug = match.params.slug;
     const location = useLocation();
     const product = useActiveProduct();
     const organizationCourses = useSelector((state) => state.subscriber.organizationCourses);

     const pathNameArr = location.pathname.split('/').filter((path) => path);
     const courseId = pathNameArr[pathNameArr.length - 2];
     const organizationCourseRelated = organizationCourses.find((orgCourse) => orgCourse.id === courseId);
     const [productRelated, setProductRelated] = useState();

     const fetchData = () => {
          dispatch(fetchSubscriberProductDetailRequest(slug));
     };

     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          if (organizationCourseRelated) {
               dispatch(setIsLoading(true));
               callApi(API_GUEST_SUBSCRIBER_PRODUCT_DETAIL_BY_ID.replace(':id', organizationCourseRelated.productId), 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              setProductRelated(response.data);
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => dispatch(setIsLoading(false)));
          }
     }, [organizationCourseRelated]); // eslint-disable-line react-hooks/exhaustive-deps

     if (!product) {
          return <CSpinner width={15} height={15} />;
     }

     let nameBreadcrumb = product.publishName + ' Event' || '';

     const productType = productRelated?.productType.trainingProductType;

     if (productRelated && PRODUCT_TYPES_REQUIRE_EVENT.includes(productType)) {
          nameBreadcrumb = productRelated?.publishName + ' Event';
     } else if (productRelated) {
          nameBreadcrumb = productRelated?.publishName;
     }

     return <span>{nameBreadcrumb}</span>;
};

const Routes = {
     path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSES,
     breadcrumb: 'Manage Seats',
     element: <Outlet />,
     children: [
          { index: true, element: <TrainingSeats /> },
          {
               path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS,
               breadcrumb: GetCourseProductName,
               children: [
                    { index: true, element: <TrainingSeatDetails /> },
                    {
                         path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS,
                         breadcrumb: 'Manage Seats',
                         element: <Seats />,
                    },
                    {
                         path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS_EVENT,
                         breadcrumb: 'Manage Seats',
                         element: <Seats />,
                    },
                    {
                         path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_EVENT_CREDITS,
                         breadcrumb: 'Manage Seats',
                         element: <EventCredits />,
                    },
                    {
                         path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_BUNDLE_SEATS,
                         breadcrumb: 'Manage Bundle Seats',
                         element: <BundleSeats />,
                    },
                    {
                         path: SUBSCRIBER_PATH.ORGANIZATIONS_COURSE_EVENT_DETAILS,
                         breadcrumb: GetCourseProductNameEvent,
                         element: <TrainingEventDetails />,
                    },
               ],
          },
     ],
};

export default Routes;
